;(() => {
  let psGallery = null

  // Avoid closing modal by OuterClick when Photoswipe is opened
  const fullscreenHandler = () => {
    document.documentElement.classList.add("fullscreen")
    psGallery.on("close", () => {
      setTimeout(() => {
        document.documentElement.classList.remove("fullscreen")
      }, HB.PswpHelpers.ANIMATION_DURATION)
    })
  }

  $(() => {
    $(document).on("click", ".photos--i", function openPropertyGallery(event) {
      psGallery = HB.PswpHelpers.propertyGalleryHandler.call(this, event)
      fullscreenHandler()
    })

    $(document).on("click", ".room-photos--i", function openRoomGallery() {
      const roomId = $(this).closest(".room-photos").data("room-id")
      psGallery = HB.PswpHelpers.roomGalleryHandlerDesktop.call(this, roomId)
      fullscreenHandler()
    })
  })
})()
